import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
//import List from '@mui/material/List';
//import ListItemButton from '@mui/material/ListItemButton';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import useMediaQuery from '@mui/material/useMediaQuery';
import { createContext, Dispatch, FC, JSX, SetStateAction, useContext, useEffect, useRef, useState } from 'react';
import { MessageDrawer } from '@deere/fuel-react/MessageDrawer';
import { MessageFlow } from '@deere/fuel-react/MessageFlow';
import { MessageInput } from '@deere/fuel-react/MessageInput';
import { MessageSent } from '@deere/fuel-react/MessageSent';
import exampleSessions from './exampleSessions';
import { sampleResponses } from './sampleResponses';
//import {welcomePrompts} from './welcomePrompts';
//import { useTheme } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import { UserDetailsContext } from '../../context/UserDetailsContext';
import { useChatbotAPI } from "../as2-onboarding-component/hooks/useClient";
import { useOktaAuth } from "@okta/okta-react";
import { useUserDetails } from "../../hooks";
import ChatBotTable from './ChatbotTable';
import Chip from '@mui/material/Chip';
import { Box, CircularProgress, List, ListItemButton, ListItemText } from '@mui/material';
import SupplierChips from './SupplierChips';
import { useChatbotContext } from '../../context';

type ApiMessage = {
    id: number;
    message: string;
    create_date: string;
    conversation_id: string;
    sender_type: 'user' | 'system';
    // Puedes añadir otros campos que sean relevantes
};
type Message = {
    sender_type: 'user' | 'system';
    message: string;
    isList: boolean;
    hasSupplierList:boolean;
};

enum ConversationStage {
    SELECT_SUPPLIER = 'SELECT_SUPPLIER',
    SELECT_ACTION = 'SELECT_ACTION',
    READY_FOR_QUERIES = 'READY_FOR_QUERIES',
}

interface ConversationState {
    stage: ConversationStage | null;
    supplierNumber: string | null;
    selectedAction: ConversationAction | null;
}

enum ConversationAction {
    CHANGE_SUPPLIER = 'CHANGE_SUPPLIER',
    CREATE_INCIDENT = 'CREATE_INCIDENT',
}

const defaultConversationState: ConversationState = {
    stage: ConversationStage.SELECT_SUPPLIER,
    supplierNumber: null,
    selectedAction: null,
};

interface ChatResponse {
    conversationId: string;
    invocationId: string;
    state: string;
    output: string;
    finishReason: string;
    isContextTrimmed: boolean;
    enrichments: any[];
    contentFlags: any[];
    moderation: Record<string, any>;
    jsonMode: boolean;
    conversationState: ConversationState;
    isList: boolean
    isFirstLoadingContext: boolean;
    hasSupplierList:boolean;
}

export interface Conversations {
    id: string;
    conver_name: string;
    create_date: Date;
    user_id: string;
}

export interface ChatInput {
    message: string;
    conversationState: ConversationState;
    isUserAdmin: boolean;
    conversationId?: string;
    userid: string;
    isFirstLoadingContext: boolean;
}



const DigitalAssistant: FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [messages, setMessages] = useState<Message[]>([]);
    const [conversations, setConversations] = useState<Conversations[]>([]);
    const [isFirstLoadingContext, setIsFirstLoadingContext] = useState(true);
    const [conversationState, setConversationState] = useState<ConversationState>(defaultConversationState);
    const [isLoading, setIsLoading] = useState(false);
    //const {supplierList} = useContext(UserDetailsContext);
    const { oktaAuth } = useOktaAuth();
    const chatbotClient = useChatbotAPI(oktaAuth.getAccessToken());
    const { oktaDetails } = useUserDetails();
    const userid = oktaDetails.userid;
    const username = oktaDetails.username || "User";
    const isUserAdmin = oktaDetails.ediItAdmin || oktaDetails.ediCoordinator;
    const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));
    const [showAllSessionsPanel, setShowAllSessionsPanel] = useState(false);
    const [conversationName, setConversationName] = useState("")
    const [isChipDisabled, setIsChipDisabled] = useState(true);
    const [ supplierNumber, setSupplierNumber] = useState<String|null>();
    const { globalConversation_id, setGlobalConversation_id} = useChatbotContext();
    const {
        isDrawerOpen,
        closeDrawer,
        toggleDrawer
    } = useChatbotContext();

    //const handleSendMessage = (message: string): void => {
    //setMessages((prevMessages) => prevMessages.concat({
    //sender_type: 'user',
    //  message
    //}));

    //  generateRandomResponse(setMessages);
    //};
    const renderMessages = (messages: Message[]): JSX.Element[] => {
    //Maps each message
    return messages.map((message, index) => {
        const MessageComponent = {
            user: MessageSent,
            system: Typography
        }[message.sender_type];

        if (message.sender_type == 'user') {
            return (

                <MessageComponent key={index}>
                    {message.message}
                </MessageComponent>
            );
        } else {
            if (message.isList) {
                const listLength = Array.isArray(message.message) ? message.message.length : 0;
                const resultText = listLength >= 10 
                    ? "It appears there are more than 10 results. Here are the latest 10 results. If you need something more specific, try adding another search parameter."
                    : "It appears these are all the results found. If it's not what you're looking for, try another search parameter.";
                
                return (
                    <div key={index}>
                        <Typography sx={{whiteSpace: 'pre-line', marginBottom: 2}}>
                            {resultText}
                        </Typography>
                        <Container maxWidth="lg" sx={{ padding: 2, overflow: 'visible' }}>
                            <ChatBotTable list={message.message} />
                        </Container>
                    </div>
                )
            }
            else if(message.hasSupplierList && !isUserAdmin){
                const hasMessageAfter = index < messages.length - 1 ;
                return(
                    <div key={index}>
                        <SupplierChips list={message.message} setSelectedChip={handleSendMessage} hasMessageAfter={hasMessageAfter}/>
                    </div>
                )
            }
            else {
                return (
                    <div
                        key={index}
                        dangerouslySetInnerHTML={{ __html: message.message }}
                        style={{
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere',
                            maxWidth: '100%',
                            whiteSpace: 'pre-wrap',
                            boxSizing: 'border-box'
                        }}
                    />
                )
            }
        }

    });
};
    const handleHistoricMessages = async (conversationId: string, event?: any): Promise<void> => {

        try {
            if(event){
            setConversationName(event?.target?.textContent?.trim())
            }

            setShowAllSessionsPanel(false)
            setIsLoading(true)
            const response = await chatbotClient.get(`/chat/messages?conversation_id=${conversationId}`);
            const mappedMessages: Message[] = response.data.map((item: { message: string; sender_type: string; is_list: any; has_supplier_list:boolean }) => {
                let parsedMessage = item.message;

                // Solo parsear como JSON si es una lista o tiene supplier list
                if (item.is_list || item.has_supplier_list) {
                    try {
                        parsedMessage = JSON.parse(item.message);
                    } catch (error) {
                        console.log("The message is not a valid JSON:", item.message);
                    }
                }

                return {
                    sender_type: item.sender_type as 'user' | 'system',
                    message: parsedMessage,
                    isList: item.is_list || false,
                    hasSupplierList: item.has_supplier_list || false
                };
            });
            setIsLoading(false)
            setMessages(mappedMessages);
            setGlobalConversation_id(conversationId)
            //setConversation_id(conversationId);
            setConversationState({
                stage: response.data[response.data.length - 1].stage,
                supplierNumber: response.data[response.data.length - 1].supplier_number,
                selectedAction: null

            })
            setSupplierNumber(response.data[response.data.length - 1].supplier_number)


        } catch (error) {
            console.error("Error al obtener mensajes históricos:", error);
        }
    };
    const fetchConversations = async () => {
        try {
            const response = await chatbotClient.get(`/chat/conversations?user_id=${userid}`);
            setConversations(response.data);
        } catch (error) {
            console.error('Error fetching conversations:', error);
        }
    };
    useEffect(()=>{
        if(globalConversation_id !== null) {
            handleHistoricMessages(globalConversation_id)
        }
    },[]);

    useEffect(() => {
        fetchConversations();
    }, [userid]);

    const handleConversationId = (conver_id: string): any => {
        //setConversation_id(conver_id)
        setGlobalConversation_id(conver_id)
    }
    const handleSendMessage = async (message: string, overrideConversationState?: ConversationState): Promise<void> => {
        setMessages((prevMessages) => prevMessages.concat({
            sender_type: 'user',
            message,
            isList: false,
            hasSupplierList: false
        }));
        setIsLoading(true);

        try {
            const isFirstMessage = messages.length === 0;

            const chatInput: ChatInput = {
                message,
                conversationId: globalConversation_id || "",
                isUserAdmin,
                conversationState: overrideConversationState ?? conversationState,
                userid,
                isFirstLoadingContext
            };

            const response = await chatbotClient.post('/chat/send', chatInput);
            const data: ChatResponse = response.data;
            setIsFirstLoadingContext(data.isFirstLoadingContext)
            if (data?.conversationId) {
                //Obtains the conversationID if exists and sets it up
                handleConversationId(data.conversationId);
            }

            if (data?.conversationState) {
                setConversationState(data.conversationState); // <-- Always update local state since it changes in the backend

                if (data.conversationState.stage === "READY_FOR_QUERIES") {
                        setSupplierNumber(data.conversationState.supplierNumber);
                        setIsChipDisabled(false); // Habilita el chip
                    }

            }

            setMessages((prevMessages) => prevMessages.concat({
                sender_type: 'system',
                message: data.output || 'Simulating response...',
                isList: data.isList,
                hasSupplierList:data.hasSupplierList
            }));


            if (isFirstMessage) {
                await fetchConversations();
            }


        } catch (error) {
            console.error('There was an error while sending the message:', error);
            setMessages((prevMessages) => prevMessages.concat({
                sender_type: 'system',
                message: 'There was an error while sending the message please try again.',
                isList: false,
                hasSupplierList:false
            }));
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        //oculta el View all Sessions por defecto
        const observer = new MutationObserver(() => {
            const items = document.querySelectorAll('.MuiListItemText-primary');
            items.forEach((item) => {
                if (item.textContent?.trim() === 'View All Sessions') {
                    const parent = item.closest('li');
                    if (parent) {
                        parent.style.display = 'none';
                    }
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);




    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight; // this will scroll to view new messages
        }
    }, [messages]);

    useEffect(() => {
        if (conversationState?.stage === "READY_FOR_QUERIES") {
            setIsChipDisabled(false);
        } else {
            setIsChipDisabled(true);
        }
    }, [conversationState]);

    const AllSessionsPanel = ({ conversations, onSelect }: {
        conversations: { id: string; conver_name: string }[];
        onSelect: (id: string) => void;
    }) => (
        <Box sx={{ padding: 2 }}>
            <Typography variant="h3">All Sessions</Typography>
            <List>
                {conversations.map((conv) => (
                    <ListItemButton key={conv.id} onClick={(event) => {
                        const target = event.target as HTMLElement;
                        const name = target.textContent?.trim();
                        if (name) {
                            setConversationName(name);
                        }
                        onSelect(conv.id);
                    }}
                    >
                        <ListItemText primary={conv.conver_name} />
                    </ListItemButton>
                ))}
            </List>
        </Box>
    );


    return (
        <>
            {isDesktop ? (
                <Button
                    onClick={toggleDrawer}
                    startIcon={<fuel-icon name={'ai_generate'} />}
                    variant={'headerAction'}
                >
                    {'EDI Agent'}
                </Button>
            ) : (
                <IconButton
                    onClick={toggleDrawer}
                >
                    <fuel-icon name={'ai_generate'} />
                </IconButton>
            )}

            <MessageDrawer
                displayTitle={!conversationName ? `Messages` : `Conversation name: ${conversationName}`}
                onClose={closeDrawer}
                open={isDrawerOpen}
                sx={{
                    // Fuel v18 fixes the message drawer paper to a narrow grid column; force it full width.
                    '&.FuelDrawer-message .MuiDrawer-paper': {
                        width: '75vw',
                        maxWidth: '100vw',
                        gridTemplateColumns: '1fr',
                        overflowX: 'hidden',
                        boxSizing: 'border-box'
                    },
                    '& .MuiList-root > li:last-child': {
                        display: 'none !important',
                        color: 'red !important'
                    },
                    '& .MuiCardHeader-root.css-xqj0hp-MuiCardHeader-root': {
                        position: 'sticky !important',
                        top: '0 !important',
                        backgroundColor: '#f5f5f5 !important',
                        paddingBottom: '20px !important',
                        zIndex: '10 !important'
                    },
                     '& .css-1kfsf9c-MuiInputBase-input': {
                        height: '50px !important'
                    },
                    '& .css-t6a5wr': {
                        position: 'sticky !important',
                        top: '0 !important',
                        backgroundColor: '#f5f5f5 !important',
                        paddingBottom: '20px !important',
                        zIndex: '10 !important'
                    },


                }}
                slotProps={{
                    messageHistory: {
                        onNewSession: () => {
                            setGlobalConversation_id("");
                            setMessages([]);
                            setConversationName("")
                            setConversationState(defaultConversationState);
                        },
                        sessions: conversations.map((conversation, index) => ({
                            label: conversation.conver_name,
                            onClick: (e) => handleHistoricMessages(conversation.id, e),
                            key: index
                        })),
                        secondaryActions: [
                            {
                                startIcon: <fuel-icon name={'menu'} />,
                                label: 'View All Conversations',
                                onClick: () => setShowAllSessionsPanel(true)
                            },
                            /* { startIcon: <fuel-icon name={'info'} />, label: 'About' }, */
                            /* { startIcon: <fuel-icon name={'help'} />, label: 'Help' }, */
                            /* { startIcon: <fuel-icon name={'settings'} />, label: 'Settings' } */
                        ]
                    }
                }}
                title={'EDI Agent'}
            >

                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
                    {showAllSessionsPanel ? (

                        <Box sx={{ padding: 2, flex: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                                <IconButton onClick={() => setShowAllSessionsPanel(false)}>
                                    <fuel-icon name="keyboard_arrow_left" />
                                </IconButton>
                                <Typography variant="h3" sx={{ marginLeft: 1 }}>All Conversations</Typography>
                            </Box>
                            <AllSessionsPanel
                                conversations={conversations}
                                onSelect={(id) => {
                                    handleHistoricMessages(id);
                                    setShowAllSessionsPanel(false);
                                }}
                            />
                        </Box>
                    ) : (
                        <>
                            <Box sx={{ flex: 1 }}>
                                <CardContent sx={{
                                    minHeight: 'auto',
                                    overflow: 'visible',
                                    width: '100%',
                                    maxWidth: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    boxSizing: 'border-box'
                                }}>
                                    <MessageFlow ref={containerRef}>
                                        <Typography color={'secondary'} variant={'bodySmall'}>
                                            {/* Mensaje de bienvenida */}
                                        </Typography>
                                        {isUserAdmin
                                            ? <AdminWelcomeMessage username={username} />
                                            : <SupplierWelcomeMessage username={username} setSelectedChip={handleSendMessage} />}
                                        {renderMessages(messages)}
                                        <Container maxWidth={'xl'}>
                                            {isLoading && <LinearProgress sx={{ width: 'auto' }} />}
                                        </Container>
                                    </MessageFlow>
                                </CardContent>
                            </Box>

                            <Box sx={{ borderTop: '1px solid #ccc', padding: 2, position: 'sticky', bottom: 0, backgroundColor: '#f5f5f5', zIndex: 10 }}>
                                {!isUserAdmin && (
                                    <>
                                        <Chip sx={{ padding: 4, bottom: 4, left: 15, my: 4 }} label="Change supplier number" disabled={isChipDisabled} onClick={() =>
                                        handleSendMessage("I would like to change the supplier number", {
                                            stage: null,
                                            supplierNumber: "",
                                            selectedAction: ConversationAction.CHANGE_SUPPLIER
                                        })}
                                        />

                                        <Typography sx={{ mx: 7 }}>
                                            {isChipDisabled ? (
                                                "Current supplier number is not assigned"
                                            ) : (
                                                <>
                                                    My current supplier is:{" "}
                                                    <Box component="span" sx={{ color: 'darkgreen', fontWeight: 'bold' }}>
                                                        {supplierNumber}
                                                    </Box>
                                                </>
                                            )}
                                        </Typography>
                                    </>
                                )}

                                <CardActions>
                                    <MessageInput
                                        onMessageSend={handleSendMessage}
                                        slotProps={{
                                            input: {
                                                onKeyDown: (e) => {
                                                    if (e.key === 'Enter' && !isLoading) {
                                                        const target = e.target as HTMLInputElement;
                                                        const message = target.value.trim();
                                                        if (message) {
                                                            handleSendMessage(message);
                                                            target.value = '';
                                                        }
                                                    }
                                                },
                                            },
                                            sendAction: isLoading
                                                ? {
                                                    children: <CircularProgress size={20} />,
                                                    disabled: true,
                                                }
                                                : {
                                                    onClick: () => {
                                                        const input = document.querySelector('input') as HTMLInputElement;
                                                        const message = input?.value.trim();
                                                        if (message) {
                                                            handleSendMessage(message);
                                                            input.value = '';
                                                        }
                                                    },
                                                },
                                            micAction: isLoading
                                                ? {
                                                    children: null,
                                                    disabled: true,
                                                }
                                                : {},
                                        }}
                                    />
                                </CardActions>
                            </Box>
                        </>
                    )}
                </Box>



            </MessageDrawer>
        </>
    );
};

const AdminWelcomeMessage = ({ username }: { username: string }) => (
    <Typography style={{ whiteSpace: 'pre-line' }}>
        {`Welcome ${username} I am a virtual assistant created by the EDI team. I am here to help you with your EDI transactions. Since you are an EDI IT admin or EDI coordinator, you can search for documents using natural language with any of these values, or any combination of them:
• Supplier ID
• Purchase order
• Part Number
• ASN number/Shipment number
• Interchange sender or receiver ID
• Group sender or receiver ID
• Packlist

Just ask me anything about your EDI documents and I'll help you find what you need.`}
    </Typography>
);

const SupplierWelcomeMessage = ({ username, setSelectedChip }: { username: string, setSelectedChip: (message: string) => Promise<void> }) => {
    const [supplierList] = useState([{ supplier_number: "0000025392" }, { supplier_number: "0000069731" }]);
    const [selectedSupplier, setSelectedSupplier] = useState<string | null>(null);

    const handleChipClick = async (supplierNumber: string) => {
        setSelectedSupplier(supplierNumber);
        await setSelectedChip(supplierNumber);
    };

    return (
        <Typography style={{ whiteSpace: 'pre-line' }}>
            {`Welcome ${username}!! I am a virtual assistant created by the EDI team. I am here to help you with your EDI transactions. Since we detected you are a supplier user. Please select one of your related supplier numbers.\n`}
            {supplierList.map((s, key) => (
                <Chip
                    key={key}
                    label={s.supplier_number}
                    aria-pressed={selectedSupplier === s.supplier_number}
                    disabled={selectedSupplier !== null}
                    onClick={() => handleChipClick(s.supplier_number)}
                />
            ))}
        </Typography>
    );
};


export default DigitalAssistant;

